var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal overflow-auto",
      attrs: { "select-cy": "update-user-details" }
    },
    [
      _c(
        "div",
        { staticClass: "card inner" },
        [
          _c("div", { staticClass: "header" }, [
            _vm._m(0),
            _c(
              "div",
              {
                staticClass: "close",
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              },
              [_c("i", { staticClass: "icn icn-x sm" })]
            )
          ]),
          _c("div", { staticClass: "content" }, [
            _c(
              "form",
              {
                attrs: { id: "user-edit" },
                on: {
                  submit: [
                    function($event) {
                      $event.preventDefault()
                    },
                    _vm.edit
                  ]
                }
              },
              [
                _c("h3", { staticClass: "sub-title" }, [_vm._v("Details")]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.editItem.firstName,
                          expression: "editItem.firstName"
                        }
                      ],
                      attrs: {
                        required: "",
                        type: "text",
                        placeholder: "First name",
                        maxlength: "127",
                        autocomplete: "nope",
                        "data-cy": "first"
                      },
                      domProps: { value: _vm.editItem.firstName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.editItem,
                            "firstName",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.editItem.lastName,
                          expression: "editItem.lastName"
                        }
                      ],
                      attrs: {
                        required: "",
                        type: "text",
                        placeholder: "Last name",
                        maxlength: "127",
                        autocomplete: "nope",
                        "data-cy": "last"
                      },
                      domProps: { value: _vm.editItem.lastName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.editItem,
                            "lastName",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.editItem.email,
                          expression: "editItem.email"
                        }
                      ],
                      attrs: {
                        required: "",
                        type: "text",
                        pattern: "[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
                        title: "E.g: johndoe@example.com",
                        placeholder: "Email",
                        maxlength: "127",
                        autocomplete: "nope",
                        "data-cy": "email"
                      },
                      domProps: { value: _vm.editItem.email },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.editItem, "email", $event.target.value)
                          },
                          function($event) {
                            return _vm.onEmailInput()
                          }
                        ]
                      }
                    })
                  ])
                ]),
                _c("h3", { staticClass: "sub-title" }, [_vm._v("Company")]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.editItem.companyId,
                            expression: "editItem.companyId"
                          }
                        ],
                        attrs: { required: "" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.editItem,
                              "companyId",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(_vm.companies, function(c) {
                        return _c(
                          "option",
                          {
                            key: c.id,
                            domProps: {
                              value: c.id,
                              selected: c.id === _vm.item.companyId
                            }
                          },
                          [_vm._v(" " + _vm._s(c.name) + " ")]
                        )
                      }),
                      0
                    )
                  ])
                ])
              ]
            )
          ]),
          _vm.errorMessage
            ? _c("Alert", { attrs: { message: _vm.errorMessage } })
            : _vm._e(),
          _c("div", { staticClass: "footer" }, [
            _c(
              "button",
              {
                staticClass: "secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              },
              [_vm._v("Cancel")]
            ),
            _c("div", { staticClass: "flex-grow" }),
            _c(
              "button",
              {
                attrs: {
                  type: "button",
                  disabled: !_vm.canSubmit,
                  "select-cy": "submit-edit-user"
                },
                on: {
                  click: function($event) {
                    return _vm.edit()
                  }
                }
              },
              [
                !_vm.isValidating ? _c("span", [_vm._v("Save")]) : _vm._e(),
                _vm.isValidating
                  ? _c("span", { staticClass: "icon" }, [
                      _c("i", {
                        staticClass: "icn icn-refresh sm animate-reverse-spin"
                      })
                    ])
                  : _vm._e()
              ]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("Edit General Information")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }